import { FC } from 'react';
import FloatButton, { ProFloatButtonProps } from './floatButton';
import ProFloatButtonGroup, { ProFloatButtonGroupProps } from './group';
import ProFloatButtonBackTop, { ProBackTopProps } from './backTop';

export type IFloatButtonComponent = FC<ProFloatButtonProps> & {
  Group: FC<ProFloatButtonGroupProps>;
  BackTop: FC<ProBackTopProps>;
};

const TransFloatButton = FloatButton as IFloatButtonComponent;
TransFloatButton.Group = ProFloatButtonGroup;
TransFloatButton.BackTop = ProFloatButtonBackTop;

export default TransFloatButton;

